export function BuySqdIcon({ color = '#3e4a5c', size = 14 }: { color?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.1589 7.31766C1.42727 7.31766 0.707639 7.26516 0 7.17196V13.0851C0.664461 13.1711 1.38409 13.2189 2.17089 13.2189C6.82691 13.2189 9.12014 11.5728 11.5477 9.83346C14.1456 7.96986 16.8346 6.04188 22.1863 6.04188C23.4936 6.04188 24.6402 6.15656 25.6669 6.35963V0.00216007H15.8127C12.8766 4.40772 7.85359 7.32006 2.1589 7.32006V7.31766Z"
        fill={color}
      />
      <path
        d="M22.1863 8.19236C17.5302 8.19236 15.237 9.83846 12.8095 11.5802C10.2116 13.4437 7.52256 15.3717 2.17089 15.3717C1.39369 15.3717 0.671657 15.3287 0 15.2547V25.5661H25.6669V8.56266C24.6618 8.32856 23.52 8.19236 22.1863 8.19236Z"
        fill={color}
      />
      <path
        d="M0 5.00522C0.70524 5.11273 1.42487 5.16768 2.1589 5.16768C6.57264 5.16768 10.5234 3.15365 13.1333 0H0V5.00283V5.00522Z"
        fill={color}
      />
    </svg>
  );
}
